
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, Button, 
  Typography, List, ListItem, ListItemText, ListItemIcon 
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { HotelAvailabilityScope } from "@bandido/shared/dtos";

interface HotelAvailabilityModalProps {
  open: boolean;
  onClose: () => void;
  scope: HotelAvailabilityScope;
}

const HotelAvailabilityModal = ({ open, onClose, scope }: HotelAvailabilityModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Hotel Availability</DialogTitle>
      <DialogContent sx={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Typography variant="body1" gutterBottom>
          Hash: {scope.hash}
        </Typography>

        {scope.suppliers.map((supplier) => (
          <div key={supplier.id} style={{ marginBottom: "1rem" }}>
            <Typography variant="h6">{supplier.name}</Typography>
            <Typography variant="body2">Context: {supplier.context}</Typography>
            <Typography variant="body2">Supplier ID: {supplier.id}</Typography>
            <Typography variant="body2">Access Code: {supplier.accessCode}</Typography>

            <List dense>
              {supplier.hotels.map((hotel) => (
                <ListItem key={hotel.hotelCode}>
                  <ListItemIcon>
                    {hotel.received ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <CancelIcon color="error" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={hotel.name}
                    secondary={`Hotel Code: ${hotel.hotelCode}`}
                  />
                </ListItem>
              ))}
            </List>
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HotelAvailabilityModal;
